export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
//////////////// Code not implemented /////////////
// export const API_KEY = '9d354b64-fbc3-4662-8421-7ed69904faa5';
export const MODAL_CLOSE_SEC = 2500;
